import { SecuredClient } from '../../Core/Api/SecuredClient';
import {
    RequestPasswordResetCommandRequest,
    IRequestPasswordResetCommandRequest,
    ResetPasswordCommandRequest,
    IResetPasswordCommandRequest,
    ChangePasswordCommandRequest,
    IChangePasswordCommandRequest,
    GetMyUserProfileQueryRequest,
    IGetMyUserProfileQueryRequest,
    UserEditOwnProfileCommandRequest,
    IUserEditOwnProfileCommandRequest,
    IGetSecurityQuestionsQueryRequest,
    GetSecurityQuestionsQueryRequest,
    UpdateSecurityQuestionsCommandRequest,
    IUpdateSecurityQuestionsCommandRequest
} from '../../Core/Api/Api';

export default class UserProfileHandler {
    props: any;
    constructor(props) {
        this.props = props;
    }

    GetProfileInfo(model: IGetMyUserProfileQueryRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const request = new GetMyUserProfileQueryRequest(model);

        return client.getMyUserProfile(request);
    }

    EditProfileInfo(model: IUserEditOwnProfileCommandRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const request = new UserEditOwnProfileCommandRequest(model);

        return client.editMyUserProfile(request);
    }

    ResetPassword(model: IResetPasswordCommandRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const request = new ResetPasswordCommandRequest(model);

        return client.resetPassword(request);
    }

    ChangePassword(model: IChangePasswordCommandRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const request = new ChangePasswordCommandRequest(model);

        return client.changePassword(request);
    }

    GetSecurityQuestions(model?: IGetSecurityQuestionsQueryRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const request = new GetSecurityQuestionsQueryRequest(model);

        return client.getSecurityQuestions(request);
    }

    UpdateSecurityQuestions(model: IUpdateSecurityQuestionsCommandRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const request = new UpdateSecurityQuestionsCommandRequest(model);

        return client.updateSecurityQuestions(request);
    }
}
